<ng-container>
  @if (loading) {
    <div
      class="flex w-full">
      <div class="h-full cp-estimate w-100"></div>
    </div>
  }

  @if (estimate?.type == 'EstimateRenderConfig') {
    <estimate-default-renderer [loading]="loading"
      [estimateDisclaimerAcknowledged]="estimateDisclaimerAcknowledged"
      [estimate]="estimate"
      [externalFeatures]="features"
      [encounterId]="encounterId"
      [acknowledgedEstimateDisclaimerAt]="acknowledgedEstimateDisclaimerAt"
    [appName]="appName"></estimate-default-renderer>
  }

  @if (estimate?.type == 'GoodFaithEstimateRenderConfig') {
    <estimate-gfe-renderer [headerSections]="headerSections"
      [disclaimerSections]="disclaimerSections"
      [additionalSections]="additionalSections"
      [estimateChange]="estimateChange"
      [estimate]="estimate"
    [appName]="appName"></estimate-gfe-renderer>
  }

  @if (estimate?.type == 'EstimateAttachmentRenderConfig') {
    <estimate-attachment-renderer [loading]="loading"
      [estimateDisclaimerAcknowledged]="estimateDisclaimerAcknowledged"
    [estimate]="estimate"></estimate-attachment-renderer>
  }

  @if (estimate?.type == 'NarrativeEstimateRenderConfig') {
    <estimate-narrative-renderer [estimate]="estimate"></estimate-narrative-renderer>
  }

  @if (estimate?.type == 'LayoutEstimateRenderConfig') {
    <estimate-layout-renderer [estimate]="estimate" [language]="language"></estimate-layout-renderer>
  }

</ng-container>
